export function parseFilename(contentDisposition) {
  if (!contentDisposition) return null;

  const m1 = contentDisposition.match(/filename\*\=utf-8''([^;]+)/i);
  if (m1?.[1]) return decodeURIComponent(m1[1]);

  const m2 = contentDisposition.match(/filename=\"?([^\";]+)\"?/i);
  return m2?.[1] ?? null;
}

export function downloadBlob(blob, filename = "invoice.pdf") {
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
}
